import Vue from "vue";
import VueRouter from "vue-router";
import CustomerApp from "../views/CustomerApp.vue";
import UI_CONSTANTS from "../../uiConstants";
const SelectionPageApp = () => import("../views/SelectionPageApp.vue");
const AnbieterMapApp = () => import("../views/AnbieterMapApp.vue");
import PageNotFound from "../views/PageNotFound.vue";

Vue.use(VueRouter);

window.popStateDetected = false;
window.addEventListener("popstate", () => {
  window.popStateDetected = true;
});
const routes = [
  {
    path: "/",
    name: "home",
    // component: PageNotFound,
  },
  {
    path: "/beratung",
    component: CustomerApp,
    name: "Beratung",
  },
  {
    path: "/dialog/:dialogName",
    name: "load custom dialog",
    component: CustomerApp,
    meta: UI_CONSTANTS.meta.pflegegrad,
  },
  {
    path: "/anbieter-finder",
    name: "SelectionPageApp",
    component: SelectionPageApp,
    sensitive: true,
    meta: UI_CONSTANTS.meta.storeFinder,
  },
  {
    path: "/anbieter-finder/karte",
    component: AnbieterMapApp,
    name: "AnbieterMapApp",
    meta: UI_CONSTANTS.meta.storeFinder,
  },
  {
    path: "/:catchAll(.*)*",
    name: "PageNotFound",
    component: PageNotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
